import type {Parameter} from '../../../../parsing/types';
import {InsetDark} from '../../../ui/InsetDark';

import {ParameterRow} from './ParameterRow';

interface ParametersListProps {
	parameters: Parameter[];
}

export const ParametersList = ({parameters}: ParametersListProps) => {
	if (!parameters.length) return null;

	return (
		<InsetDark>
			{parameters.map((param) => (
				<ParameterRow key={param.name} param={param} parameters={parameters} />
			))}
		</InsetDark>
	);
};
